exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles--file__3Ciao{display:inline-block;padding:8px 14px 6px 14px;border:none;background:#5e80a7;color:#ffffff;font-size:13px;line-height:16px;text-decoration:none;text-align:center;cursor:pointer;border-radius:2px;font-weight:normal}\n", ""]);

// exports
exports.locals = {
	"file": "styles--file__3Ciao"
};